import {Kind} from 'graphql';
import {ROOT_QUERY_INCLUDE_VARIABLE_NAME} from 'src/internal/revamp/graphql/compositionFragments/constants';

import type {DirectiveNode, VariableNode} from 'graphql';

export function isRootQueryIncludeVariable(
  variableNode: VariableNode,
): boolean {
  return variableNode.name.value.endsWith(ROOT_QUERY_INCLUDE_VARIABLE_NAME);
}

export function isRootLevelIncludeDirective(directive: DirectiveNode): boolean {
  if (directive.name.value !== 'include') {
    return false;
  }

  if (typeof directive.arguments === 'undefined') {
    return false;
  }

  return directive.arguments.some(
    (arg) =>
      arg.name.value === 'if' &&
      arg.value.kind === Kind.VARIABLE &&
      isRootQueryIncludeVariable(arg.value),
  );
}
